import React from 'react';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="min-h-screen flex flex-col" data-id="element-146" data-mp="kzc12e5s8q3p">{children}</div>;
};